'use client'

import { useTranslation } from '@/hooks/client'
import { tw } from '@/lib/utils'

import { SoundBars } from './sound-bars'

const CheckedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" className="h-14 w-14">
    <circle cx="12" cy="12" r="11" stroke="#22c55e" strokeWidth="2" />
    <path d="M7 12.5l3 3 7-7" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

interface SuccessPanelProps {
  message?: string
}

export const SuccessPanel = ({ message }: SuccessPanelProps) => {
  const { t } = useTranslation()
  return (
    <div
      className={tw(
        'ring-navy/10 relative flex min-h-[460px] flex-col items-center justify-center overflow-hidden rounded-[28px] bg-white p-10 text-center ring-1',
        'shadow-[0_30px_80px_-30px_rgba(20,37,70,0.25)]'
      )}
    >
      <SoundBars
        count={12}
        className="mb-8 h-14"
        barWidth="3px"
        gapClass="gap-[4px]"
        activeColor="bg-lapis"
        durationOffset={2}
        delayStep={0.08}
      />
      <CheckedIcon />
      <h2
        className="text-navy mt-6 text-[40px] leading-tight tracking-[-0.02em]"
        style={{ fontFamily: 'var(--font-fraunces), Georgia, serif', fontWeight: 500 }}
      >
        {t('contact.messageReceivedPrefix', 'Message')}{' '}
        <em className="text-lapis italic">{t('contact.messageReceivedEmphasis', 'received')}</em>.
      </h2>
      <p className="text-navy/70 mt-3 max-w-[320px] text-[15px] leading-[1.55]">
        {message || t('contact.successMessage', 'A member of our team will be in touch with you shortly.')}
      </p>
    </div>
  )
}
